"use client"

import { Suspense } from "react"

import { isDarel } from "~/lib/brand"
import { productMetafields } from "~/lib/shopify/constants"
import { getLocalizedMetafields } from "~/lib/shopify/utils/get-localized-metafields"
import useLocale from "~/hooks/useLocale"
import { KleepWidget } from "~/components/ui/ProductHeader/components/ProductDetails/components/KleepWidget"
import VariantsRow from "~/components/ui/ProductHeader/components/ProductDetails/components/VariantsRow"
import { ClientViewItem } from "~/components/shared/AnalyticsEvents/ClientViewItem/index.client"
import { metafieldsToObject } from "~/utils/metafields-to-object"
import type { VariantsRowWithVariantSwitchProps } from "~/app/[locale]/products/[slug]/(components)/VariantsRowWithVariantSwitch"
import { useVariantSwitch } from "~/app/[locale]/products/[slug]/(hooks)/useVariantSwitch"

function ClientVariantsRowWithVariantSwitch({
  className,
  variants,
  productType,
  stockAlertEnabled,
  defaultVariant,
  trackingData,
  isInAddToCartPopin,
  withTracking,
  label,
  withKleepWidget = false,
  product,
}: VariantsRowWithVariantSwitchProps) {
  const { activeVariant, onChange } = useVariantSwitch({ variants, defaultVariant })
  const locale = useLocale()
  const metafields =
    product.metafields && metafieldsToObject(product.metafields, getLocalizedMetafields(productMetafields, locale))
  const modelMeasurements = metafields?.modelMeasurements

  return (
    <>
      <VariantsRow
        className={className}
        variants={variants}
        defaultVariant={defaultVariant}
        onChange={onChange}
        productType={productType}
        modelMeasurements={modelMeasurements}
        stockAlertEnabled={stockAlertEnabled}
        isInAddToCartPopin={isInAddToCartPopin}
        label={label}
        withKleepWidget={withKleepWidget}
      />

      {isDarel && withKleepWidget && (
        <Suspense>
          <KleepWidget id={product?.id} variants={variants} trackingData={trackingData} product={product} />
        </Suspense>
      )}
      {withTracking && <ClientViewItem activeVariant={activeVariant} product={product} />}
    </>
  )
}

export default ClientVariantsRowWithVariantSwitch
